
const extraEventData = (event) => {
    if (event.ratio) return ` (${event.ratio})`
    if (event.epsEstimate && event.when !== 'yesterday') return ` (EPS est. $${event.epsEstimate})`
    if (event.dividendRate) return ` (Div. $${event.dividendRate})`
}

export default extraEventData;
